import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UtensilsIcon, PackageIcon, XIcon } from 'lucide-react';
interface TableOrderCheckProps {
  tableNumber: string;
  orderNumber: string;
  onAddMore: () => void;
  onViewOrder: () => void;
  onClose: () => void;
}
export function TableOrderCheck({
  tableNumber,
  orderNumber,
  onAddMore,
  onViewOrder,
  onClose
}: TableOrderCheckProps) {
  return <AnimatePresence data-id="element-1296">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-1297">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="w-full max-w-sm bg-surface rounded-2xl border border-gray-800 shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-1298">
          {/* Header */}
          <div className="relative bg-dorado/10 border-b border-dorado/20 px-6 py-5 text-center" data-id="element-1299">
            <button onClick={onClose} className="absolute top-3 right-3 p-1.5 text-gray-500 hover:text-white transition-colors" data-id="element-1300">
              <XIcon className="w-4 h-4" data-id="element-1301" />
            </button>
            <div className="w-14 h-14 bg-dorado/20 rounded-full flex items-center justify-center mx-auto mb-3 border-2 border-dorado/30" data-id="element-1302">
              <span className="text-2xl" data-id="element-1303">🍽️</span>
            </div>
            <h2 className="font-heading text-xl text-white" data-id="element-1304">
              Mesa {tableNumber}
            </h2>
            <p className="text-sm text-gray-400 mt-1" data-id="element-1305">
              Ya hay un pedido activo
            </p>
          </div>

          {/* Content */}
          <div className="p-6 space-y-3" data-id="element-1306">
            <div className="bg-surface-light rounded-xl p-4 border border-gray-700 text-center" data-id="element-1307">
              <p className="text-gray-400 text-sm" data-id="element-1308">
                El pedido{' '}
                <span className="text-white font-bold" data-id="element-1309">#{orderNumber}</span>{' '}
                está en proceso para esta mesa.
              </p>
            </div>

            <p className="text-xs text-gray-500 text-center" data-id="element-1310">
              ¿Qué querés hacer?
            </p>

            {/* Options */}
            <button onClick={onAddMore} className="w-full px-5 py-4 bg-dorado text-carbon font-bold rounded-xl flex items-center justify-center gap-3 active:scale-[0.97] transition-transform shadow-lg shadow-dorado/15" data-id="element-1311">
              <UtensilsIcon className="w-5 h-5" data-id="element-1312" />
              Agregar más productos
            </button>

            <button onClick={onViewOrder} className="w-full px-5 py-3.5 bg-surface-light border border-gray-700 text-white font-semibold rounded-xl flex items-center justify-center gap-3 hover:bg-gray-800 transition-colors" data-id="element-1313">
              <PackageIcon className="w-5 h-5 text-dorado" data-id="element-1314" />
              Ver pedido actual
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}